import { QueryClient, queryOptions, UseQueryOptions } from "@tanstack/react-query";
import { Build, Job } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";
import { useBuildStore } from "~/components/build/Show/lib/useBuildStore";

export const jobQueryKey = (build: Build, jobId: string) => {
  return ["build", build.id, "jobs", jobId];
};

export const jobQueryOptions = (
  build: Build,
  jobId: string,
  queryOptionsArgs: Omit<UseQueryOptions<Job>, "queryKey" | "queryFn"> = {},
) => {
  return queryOptions({
    queryKey: jobQueryKey(build, jobId),
    queryFn: ({ signal }) =>
      fetchJob(build.buildDataBasePath, jobId, signal).then((job) => {
        useBuildStore.getState().setJobs([job]);
        return job;
      }),
    ...queryOptionsArgs,
  });
};

export const setJobQueryData = (build: Build, job: Job, queryClient: QueryClient) => {
  queryClient.setQueryData(jobQueryKey(build, job.id), job);
};

export const fetchJob = async (
  buildDataBasePath: Build["buildDataBasePath"],
  jobId: string,
  signal: AbortSignal,
): Promise<Job> => {
  const url = new URL(`${buildDataBasePath}/jobs`, window.location.origin);
  url.searchParams.set("uuid", jobId);

  const response = await fetcher<{ records: Job[] }>(url, true, { signal });
  const job = response.records[0];

  if (!job) {
    throw new Error("Job does not exist");
  }

  return job;
};
